export const illustratedEmptyStateRootClass = "flex flex-col items-center gap-3";

export const illustratedEmptyStateIconWellClass =
  "rounded-xl bg-gradient-to-br from-light-purple/20 to-gradient-light/30 p-3";
